import { render, staticRenderFns } from "./SearchPages.vue?vue&type=template&id=086bf9da&scoped=true&"
import script from "./SearchPages.vue?vue&type=script&lang=js&"
export * from "./SearchPages.vue?vue&type=script&lang=js&"
import style0 from "./SearchPages.vue?vue&type=style&index=0&id=086bf9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bf9da",
  null
  
)

export default component.exports